import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import { bindActionCreators, Dispatch } from "redux";
import { addNotification as addNotificationAction, clearNotifications as clearNotificationsAction } from "../../actions/notificationsActions";
import UserSettings from '../settings/model/Settings';
import Notification from './Notification';

interface IMessageNotificationProps {
  notifications: Notification[];
  settings: UserSettings;
  addNotification: (notification: Notification) => any;
  clearNotifications: () => any;
}

interface IMessageNotificationState {
  isErrorOpen: boolean;
}

export class MessageNotification extends React.Component<IMessageNotificationProps, IMessageNotificationState> {
  constructor(props: IMessageNotificationProps) {
    super(props);
    this.state = {
      isErrorOpen: this.props.notifications ? this.props.notifications.filter((n) => n.isError).length > 0 : false,
    };
    this.dismissErrorNotification = this.dismissErrorNotification.bind(this);
  }

  public dismissErrorNotification() {
    this.props.clearNotifications();
    this.setState({ isErrorOpen: false });
  }

  public render() {
    const errorMessages = this.props.notifications ? this.props.notifications.filter((n) => n.isError).map((n, index) => {
      return (<p key={index}><FormattedMessage id={n.messageKey ? n.messageKey : 'unknown'} defaultMessage={n.message} /></p>)
    }) : [];
    const isOpen = this.state.isErrorOpen || this.props.notifications ? this.props.notifications.filter((n) => n.isError).length > 0 : false;
    return (
      <div>
        {errorMessages.length > 0 &&
          <Alert color="danger" className="text-center" isOpen={isOpen} toggle={this.dismissErrorNotification}>
            {errorMessages}
          </Alert>}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    notifications: state.notifications.notifications,
    settings: state.settings.settings,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    addNotification: bindActionCreators(addNotificationAction, dispatch),
    clearNotifications: bindActionCreators(clearNotificationsAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageNotification);


// WEBPACK FOOTER //
// ./src/components/common/MessageNotification.tsx